import { Icon, IconButton, Link, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { FaFacebookF, FaPinterestP, FaXTwitter } from "react-icons/fa6";
import useSite from "../../../hooks/use-site";

const icons = {
  facebook: FaFacebookF,
  twitter: FaXTwitter,
  pinterest: FaPinterestP,
};

const ShareLinks = () => {
  const {
    post: { shareLinks },
  } = useSite();

  return (
    <Stack
      align="center"
      justify="center"
      position="sticky"
      top="100px"
      direction={{ base: "row", lg: "column" }}
      gap={4}
    >
      <Text fontSize="sm" color="green.700" mb={0}>
        SHARE
      </Text>
      {Object.keys(icons).map((key) => (
        <IconButton
          href={shareLinks[key]}
          key={key}
          target="_blank"
          maxH="25px"
          as={Link}
          variant="outline"
          size="lg"
          py={5}
          borderRadius="md"
          borderColor="green.300"
          icon={<Icon as={icons[key]} w="15px" h="15px" color="green.400" />}
        />
      ))}
    </Stack>
  );
};

ShareLinks.defaultProps = {
  align: "left",
};

export default ShareLinks;
